export default {
    projects: [
        {
            title: 'Liiteri',
            description: `Liiteri is a Finland based application, a circular economy solution to 
            reduce the carbon footprint from everyday living. Liiteri smart digital hub is a strong 
            foundation of Share economy and sustainability. With a handy Mobile application Liiteri 
            hub can be accessed 24/7 to loan expensive tools and other domestic equipments.`,
            images: [
                { src: 'https://drive.google.com/uc?export=download&id=1DeF_lyQ7n0sfJwM5M92WNEIb32f6Jm03', alt: '' },
                { src: 'https://drive.google.com/uc?export=download&id=1iSQdj2cpuyy0NH1-HI3zrfETw_PW3p04', alt: '' },
            ],
            tech: ['Angular', 'Nodejs'],
            category: 'E-commerce',
            tags: ['Angular', 'Nodejs', 'E-commerce', 'Tupas', 'Payment', 'Multi-Lingual', 'Roles'],
            urls: [
                { title: 'web', link: 'https://liiteri.net/' },
                { title: 'mobile', link: 'https://play.google.com/store/apps/details?id=com.liiteri' }
            ],
        },
        {
            title: 'TöitäSuomesta',
            description: `TöitäSuomesta is a Finnish service intended to facilitate the rural worker and to 
            solve rural employment problems. It supports growth in rural businesses and provide 
            opportunities for employment completely free of charge. The rural businesses need assistance to 
            improve the working conditions and to meet the market and challenges.`,
            images: [
                { src: 'https://drive.google.com/uc?export=download&id=10qNlA5WWYBHYbD-bM3SGVPpFt92u83ye', alt: '' },
                { src: 'https://drive.google.com/uc?export=download&id=1Yvt-_n3yb5SwSt0_CMsZY0G_wdPnaXOC', alt: '' },
            ],
            tech: ['Angular', 'Nodejs'],
            category: 'Job Portal',
            tags: ['Angular', 'Nodejs', 'Job Portal', 'Tupas', 'Multi-Lingual', 'Roles'],
            urls: [{ link: 'web', link: 'https://app.toitasuomesta.fi/en/' }],
        },
        {
            title: 'The Fizz',
            description: `The FIZZ Netherlands is the Dutch operator of the FIZZ Student houses and 
            The FIZZ Young Professionals Houses in The Netherlands. Book your fully furnished studio 
            online, pack your suitcase, move in without any hassle and make yourself comfortable.`,
            images: [
                { src: 'https://drive.google.com/uc?export=download&id=1Bmv0JPwTxIwGgrgPQvnPnVnYzRnywaZD', alt: '' },
                { src: 'https://drive.google.com/uc?export=download&id=1-rfg4Bz9CLWCqsv02xpxtRwXfr3mItA6', alt: '' },
            ],
            tech: ['React', 'Nodejs', 'SCSS'],
            category: 'Job Portal',
            tags: ['React', 'Nodejs', 'SCSS', 'Mobile app', 'IoT', 'Multi-Lingual', 'Roles'],
            urls: [{ title: 'web', link: 'https://www.the-fizz.com/en/' }, { title: 'mobile', link: 'https://play.google.com/store/apps/details?id=com.app.p4830JG' }],
        },
        {
            title: 'Ruukki',
            description: `Integrated with Crowdsourced and Local delivery \n
            An online platform which promotes local food delivery along with Crowdsourced delivery option. 
            The platform provides an opportunity for local food producers to market their products.\n
            The consumers can choose between Pick up themselves, Local delivery or Crowdsourced delivery. 
            The crowdsourced delivery request is visible to a network of 2476 users who are available to deliver 
            products. As the request for the delivery is visible notification is sent to users available in that 
            specific area, who then accept the delivery and coordinate with the consumer.`,
            images: [
                { src: 'https://drive.google.com/uc?export=download&id=1SJC1CpeVzZq5El5QUzycdyNrepY86whu', alt: '' },
                { src: 'https://drive.google.com/uc?export=download&id=1F3mvOwq8Lbxftt_IcGickExnFXamQEQl', alt: '' },
            ],
            tech: ['React', 'Nodejs', 'SCSS'],
            category: 'E-commerce',
            tags: ['Angular', 'Nodejs', 'SCSS', 'Web app', 'E-commerce', 'Multi-Lingual', 'Roles'],
            urls: [{ title: 'web', link: 'https://digikyla.fi/m-ruukki/' }],
        },
    ]
}